import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal";
import {
  ICellRendererParams,
  renderDashOr,
} from "@/shared/foundation/primitives/Table";

/**
 * A single shared definition so every resource table renders principals
 * identically.
 */
export const renderPrincipal = renderDashOr((params: ICellRendererParams) => (
  <RobotoPrincipalUnderlineLink principal={params.value as string} icon />
));
